// Полный текст при наведении на обрезанный текст — для всего приложения.
// Подсказка (title) ставится только на сам обрезанный текстовый элемент: текст с многоточием
// или однострочный текст со скрытым переполнением, длинное значение в поле ввода.
// Прокручиваемые области (таблица, списки) и большие блоки не трогаем.
// Свои title/подсказки не трогаем; наш title помечаем и снимаем, когда он больше не нужен.

const MARK = "msAutoTitle";
const MAX_DEPTH = 3;
const MAX_TEXT = 400;
const SKIP_TAGS = new Set(["TABLE", "TBODY", "THEAD", "TR", "UL", "OL", "FORM", "BODY", "HTML"]);

const isField = (el) => el.tagName === "INPUT" || el.tagName === "TEXTAREA";

const fullText = (el) => (isField(el) ? el.value : el.innerText || el.textContent || "").replace(/\s+/g, " ").trim();

const isClippedText = (el) => {
  if (SKIP_TAGS.has(el.tagName) || el.clientWidth === 0) return false;
  if (isField(el)) return el.scrollWidth > el.clientWidth + 1;
  const style = getComputedStyle(el);
  // прокручиваемая область — это не обрезанный текст
  if (style.overflowX === "auto" || style.overflowX === "scroll" || style.overflowY === "auto" || style.overflowY === "scroll") return false;
  const singleLine = style.textOverflow === "ellipsis" || style.whiteSpace.startsWith("nowrap");
  if (singleLine && style.overflowX !== "visible" && el.scrollWidth > el.clientWidth + 1) return true;
  // многострочное обрезание (line-clamp)
  return !!style.webkitLineClamp && style.webkitLineClamp !== "none" && el.scrollHeight > el.clientHeight + 1;
};

const onOver = (event) => {
  let el = event.target;
  for (let depth = 0; el && el.nodeType === 1 && depth < MAX_DEPTH; depth++, el = el.parentElement) {
    const ours = !!el.dataset[MARK];
    if (el.title && !ours) return; // у элемента своя подсказка
    if (isClippedText(el)) {
      const text = fullText(el);
      if (text && text.length <= MAX_TEXT) {
        if (el.title !== text) el.title = text;
        el.dataset[MARK] = "1";
        return;
      }
    }
    if (ours) {
      el.removeAttribute("title");
      delete el.dataset[MARK];
    }
  }
};

export const installTruncatedTitles = () => {
  if (typeof document === "undefined" || document.__msTruncatedTitles) return;
  document.__msTruncatedTitles = true;
  document.addEventListener("mouseover", onOver, { passive: true, capture: true });
};
